module.exports = __webpack_public_path__ + "static/img/aiAbility-img1.ccd291e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeaturesPhone/aiAbility-img1.png
// module id = Xx3V
// module chunks = 0